export class UserSearchParams {
    searchText: string;
    roleId: number;
    userType: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/account/shared/account-user/user-search-params.ts